import { TNormalizedVisibilityLevel } from 'src/types/normalizedResponseTypes';
import { request } from './request';

export const fetchVisibilityLevels = () =>
  request<TNormalizedVisibilityLevel[]>({
    url: '/api/v1/visibility-levels',
    method: 'GET',
  });
